export default () => {
    return {
        feedback: {
            title: 'O que achou do texto?',
            success1: 'Obrigado. Como podemos melhorar mais?',
            success2: 'Obrigado. Como podemos melhorar?',
            success3: 'Obrigado pelo feedback!',
            error: 'Desculpe, Ocurreu um erro ao enviar o seu feedback!',
            send: 'Enviar',
            textareaPlaceholder: 'Escreva aqui',
        },
    };
};
//# sourceMappingURL=ptBr.js.map